module.exports = __webpack_public_path__ + "static/media/iphone-x.ff1daa9e.png";